<section class="hero-section">
  <div class="hero-container floating">
    <h1 class="hero-title">{{ "page.landing.main.title" | translate }}</h1>
    <p class="hero-subtitle">{{ "page.landing.main.description" | translate }}</p>
    <a routerLink="/risks" class="cta-button">{{ "page.landing.main.button" | translate }}</a>
  </div>
</section>

<section class="global-dna-section" id="global-dna">
  <!-- Loading -->
  <div *ngIf="(globalDnaDataSource.loading$ | async) || (differentRisksDataSource.loading$ | async)" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>{{ "common.loading" | translate }}</p>
  </div>

  <div class="container" *ngIf="(globalDnaDataSource.loading$ | async) === false && (differentRisksDataSource.loading$ | async) === false">
    <!-- Global DNA feature block -->
    <div
      class="global-dna-header"
      *ngIf="globalDNA"
      role="button"
      tabindex="0"
      (click)="goToRisk(globalDNA.identifier.value)"
      (keydown.enter)="goToRisk(globalDNA.identifier.value)"
      (keydown.space)="goToRisk(globalDNA.identifier.value)"
    >
      <h2 class="global-dna-title">{{ globalDNA.title }}</h2>
      <p class="global-dna-description">{{ globalDNA.description }}</p>
      <a [routerLink]="['/risks', globalDNA.identifier.value]" class="learn-more-btn">
        {{ "button.learnMore" | translate }}
      </a>
    </div>

    <!-- Different Risks Carousel -->
    <div class="carousel-section" *ngIf="differentRisks.length > 0">
      <app-carousel [items]="differentRisks" [itemsPerView]="2">
        <ng-template let-risk let-isLastSlide="isLastSlide">
          <div
            class="dna-test-card"
            role="button"
            tabindex="0"
            (click)="goToRisk(risk.identifier.value)"
            (keydown.enter)="goToRisk(risk.identifier.value)"
            (keydown.space)="goToRisk(risk.identifier.value)"
          >
            <h3 class="test-card-title">{{ risk.title }}</h3>
            <div class="test-card-content" [innerHTML]="risk.description"></div>
            <a [routerLink]="['/risks', risk.identifier.value]" class="card-learn-more">
              {{ "button.learnMore" | translate }}
            </a>
          </div>

          <div *ngIf="isLastSlide" class="dna-test-card dna-test-card--more" routerLink="/risks">
            <div class="more-risks-content">
              <h3 class="test-card-title">{{ "page.landing.main.button" | translate }} →</h3>
            </div>
          </div>
        </ng-template>
      </app-carousel>
    </div>

    <!-- Empty state -->
    <div class="loading-container" *ngIf="differentRisks.length === 0">
      {{ "risks.empty" | translate }}
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section class="testimonials-section">
  <div class="container">
    <h2 class="section-title">{{ "page.landing.review.title" | translate }}</h2>
    <div class="testimonials-grid">
      <!-- Testimonial 1 -->
      <div class="testimonial-card">
        <div class="testimonial-avatar">📱</div>
        <p class="testimonial-text">
          Gloria test was a game-changer! At-home blood sample collection was painless and easy to do. I found thyroid issue early, took
          action, and now I am confident to lead a healthier life!
        </p>
      </div>

      <!-- Testimonial 2 -->
      <div class="testimonial-card">
        <div class="testimonial-avatar">📱</div>
        <p class="testimonial-text">
          The test helped me to identify my genetic predisposition to cardiovascular disease, including an increased risk of coronary heart
          disease, and to start a healthier lifestyle. The app gave me personalized recommendations on how
        </p>
      </div>

      <!-- Testimonial 3 -->
      <div class="testimonial-card">
        <div class="testimonial-avatar">📱</div>
        <p class="testimonial-text">
          As a geneticist I encourage everyone to discover their genetic predisposition to take proactive steps to prevent or delay the
          onset of health problems. Being proactive about your health will help you live longer and healthier.
        </p>
      </div>
    </div>
  </div>
</section>
